import { useApiClient } from '../useApi/useApiClient';
import {
    IUploadContestRequest,
    IUploadContestRequestBody,
    IUploadContestResponse,
} from './useUploadContest.interfaces';

export const useUploadContest = () => {
    const { fetch, loading } = useApiClient<IUploadContestResponse>();

    const uploadContest = async (request: IUploadContestRequest, body: IUploadContestRequestBody) =>
        await fetch({
            url: `/contest-graphic/${request.slug}`,
            method: 'POST',
            body,
            contentType: 'multipart/form-data',
        });

    return {
        uploadContest,
        loading,
    };
};
